import React from "react";
import {DropdownButton, Dropdown, Tabs} from "react-bootstrap";
import "../../styles/Views.css"
import TableView from "./TableView";
import VisualizationView from "./VisualizationView";

const CommentsView = () =>{
    const [qid, SelectQid] = React.useState("course");
    const [view, SelectView] = React.useState("table");
    const [title, SetTitle] = React.useState("Select Question");
    const [tab, SelectTab] = React.useState("");



    const handleTableView = () =>{
        SelectView("table")
        SelectTab("tab-select")
    }

    const handleBubbleView = () =>{
        SelectView("bubble")
    }

    const handleQuestionSelect = (e) =>{
        SelectQid(e)
        SetTitle(e)
    }

    React.useEffect(()=>{

    }, [qid])


    return(
        <div className={"viewbox"}>
            <div className={"nav-top"}>
                <DropdownButton id="dropdown-basic-button" title={title} onSelect={handleQuestionSelect}>
                  <Dropdown.Item eventKey={"course"}>Comments on overall assessment of this course.</Dropdown.Item>
                  <Dropdown.Item eventKey={"instructor"}>Comments on overall assessment of this instructor.</Dropdown.Item>
                </DropdownButton>

                <div className={"nav-button"}>
                    <a onClick={handleTableView} className={(view === "table")?'tab-select':'tab'}>Table View</a>
                </div>
                <div className={"nav-button"}>
                    <a onClick={handleBubbleView} className={(view === "bubble")?'tab-select':'tab'}>Bubble View</a>
                </div>
            </div>

            {(view=="table")?<TableView qid={qid}/>:<div></div>}

            {(view=="bubble")?<VisualizationView qid={qid}/>:<div></div>}

        </div>
    )
}

export default CommentsView;